
export const V1 = process.env.REACT_APP_API_BASE ;
export const V2 = process.env.REACT_APP_API_URL;

export const PERSONAS = 'personas/';
export const FILES = 'files/';
export const COURSES = 'courses/';
export const QUALIF = 'qualif/' ;

export const TUTORS = 'tutors/' ;


export const EVALUATIONS = 'evaluations/';

export const FINANCE = 'finance/';
export const ENROLL = 'enroll/';

export const REPORTS = 'reports/';

export const ATTENDANCE = 'attendance/';

export const CONFIG = 'config/';

export const NOTEBOOKS = 'notebooks/';
export const SCHOOLS = 'schools/';